import * as React from "react"

function Seo({ description, title, image, imageWidth, imageHeight, children }) {

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="/images/android-chrome-512x512.png" />
      <meta property="og:image:width" content={512} />
      <meta property="og:image:height" content={512} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content="@scope_hq" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta property="twitter:image" content="/images/android-chrome-512x512.png" />
      <link rel="preload" href="/fonts/Gilroy-ExtraBold.woff2" as="font" type="font/woff2" crossOrigin="anonymous" />
      {children}
    </>
  )
}

export default Seo
